import React, { useEffect, useRef, useState } from "react";
import { InstagramEmbed } from "react-social-media-embed";
import "./style.css";

/** Use `<video>` only when we have a real video URL (not a JPEG poster). */
function isVideoTileUrl(post) {
  if (post?.videoUrl) return true;
  const url = String(post?.mediaUrl ?? "");
  return /\.(mp4|webm|mov)(\?|#|$)/i.test(url);
}

function gridVideoSrc(post) {
  const v = post?.videoUrl || post?.mediaUrl;
  return v ? `${v.replace(/#.*$/, "")}#t=0.001` : undefined;
}

const HorsesAlbum = ({ media }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const modalRef = useRef();

  const openModal = (post) => {
    setSelectedPost(post);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedPost(null);
    setModalOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    if (modalOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [modalOpen]);

  const tileClass = (index) =>
    `gallery-tile-media block w-full min-h-0 aspect-square cursor-pointer object-cover transition-transform duration-300 ease-in-out ${
      index >= 4 ? "hidden md:block" : ""
    } hover:scale-[1.1]`;

  return (
    <div className="gallery-tile-grid overflow-hidden h-auto grid grid-cols-2 items-stretch sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {media?.data?.map((post, index) => {
        const stableKey = post?.sk || post?.pk || post?.permalink || `post-${index}`;
        // Grid tiles use a still (sync mirrors VIDEO → thumbnail to S3). Full post opens in the modal embed.
        return (
        <div key={stableKey} className="min-w-0 min-h-0">
            {isVideoTileUrl(post) ? (
              <video
                src={gridVideoSrc(post)}
                muted
                playsInline
                preload="metadata"
                className={tileClass(index)}
                onClick={() => openModal(post)}
              />
            ) : (
              <img
                src={post.mediaUrl || post.thumbnailUrl}
                alt=""
                loading={index < 4 ? "eager" : "lazy"}
                decoding="async"
                className={tileClass(index)}
                onClick={() => openModal(post)}
              />
            )}
        </div>
        );
      })}

      {modalOpen && selectedPost && (
        <div className="modal fixed top-0 w-full h-full flex flex-col !justify-center items-center z-50 bg-[#000] bg-opacity-70">
          <div
            ref={modalRef}
            className="modal-content h-full w-auto md:w-full max-w-[600px] bg-white overflow-y-auto scrollbar_remove"
          >
            <InstagramEmbed url={selectedPost.permalink} />
          </div>
        </div>
      )}
    </div>
  );
};

export default HorsesAlbum;
